module.exports = __webpack_public_path__ + "static/media/water-lower.6fcd670c.svg";